export const LIMIT_AUTOCOMPLETE_DEFAULT = 30;
